import { render, staticRenderFns } from "./FactsheetNavBar.vue?vue&type=template&id=bbfe8f20&"
import script from "./FactsheetNavBar.vue?vue&type=script&lang=js&"
export * from "./FactsheetNavBar.vue?vue&type=script&lang=js&"
import style0 from "./FactsheetNavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports